import type {
  FilterProfileRequest,
  projectOrchestratorApi as GeneratedApi,
} from '../rtk.generated';

export interface HighlighterProfileExportItem {
  success: boolean;
  message?: string | null;
  input: string;
  outcome: string;
}

/**
 * Batch result for the download-by-id modal. `csv` is set whenever at least one row exported,
 * including when `success` is false because other rows were skipped.
 */
export interface HighlighterProfileExportResult {
  success: boolean;
  message: string;
  items: HighlighterProfileExportItem[];
  csv?: string | null;
}

export type ExportHighlighterProfilesByIdentifierRequest = Pick<
  FilterProfileRequest,
  'internalOptions' | 'communitySlug' | 'filter'
> & {
  identifiers?: string[] | null;
};

type OrchestratorApi = typeof GeneratedApi;

/**
 * Registers the identifier export mutation.
 *
 * TODO: Delete this inject after `gen:types` includes
 * `POST /FilteredProfile/$exportByIdentifier`. `overrideExisting` hides a
 * regenerated request or response shape until then, so this hand-written
 * client and the generated one must not both stay.
 */
export function withHighlighterProfileExport<T extends OrchestratorApi>(api: T) {
  return api.injectEndpoints({
    endpoints: (build) => ({
      postFilteredProfileExportByIdentifier: build.mutation<
        HighlighterProfileExportResult,
        {
          exportHighlighterProfilesByIdentifierRequest: ExportHighlighterProfilesByIdentifierRequest;
        }
      >({
        query: (queryArg) => ({
          url: `/FilteredProfile/$exportByIdentifier`,
          method: 'POST',
          body: queryArg.exportHighlighterProfilesByIdentifierRequest,
        }),
      }),
    }),
    overrideExisting: true,
  });
}
